module.exports = __webpack_public_path__ + "static/media/a-spring-evening.b9df358e.jpg";